import { useUserStore } from '@/stores/modules/user'

/**
 // value 是指定的 按钮 名称数组
 * @param {Array} value
 * @returns {Boolean}
 * @example see @/views/permission/directive.vue
 */
export default function checkPermission(value) {
  const userStore = useUserStore()
  const rolePermission = userStore.rolePermission
  if (!rolePermission) {
    return false
  }

  // 1.1 拥有所有权限
  if (rolePermission.has_all_permissions) {
    return true
  }

  // 2.1 判断是否有按钮权限
  if (value && value instanceof Array) {
    if (value.length === 0) {
      // 如果没有指定权限名称，默认有权限
      return true
    }

    let hasPermission = false
    value.forEach((btnName) => {
      if (rolePermission.permissions[btnName]) {
        hasPermission = true
      }
    })

    return hasPermission
  } else {
    console.log('v-permission: ', value)
    console.error(`v-permission 配置值格式错误! Like v-permission="['btn-name-1','btn-name-2']"`)
    return false
  }
}

/**
 * 是否拥有某些 页面 权限中的一个
 * @param {Array} value 权限数组
 * @param {Object} _rolePermission 角色权限
 * @returns {Boolean}
 */
export function hasPermission(value, _rolePermission) {
  const userStore = useUserStore()
  const rolePermission = _rolePermission || userStore.rolePermission
  if (!rolePermission) {
    return false
  }

  // 1.1 拥有所有权限
  if (rolePermission.has_all_permissions) {
    return true
  }

  // 2.1 判断是否有权限
  if (value && value instanceof Array) {
    if (value.length === 0) {
      // 如果没有指定权限名称，默认有权限
      return true
    }
    return value.some((permission) => rolePermission.permissions[permission])
  }
  console.error(`配置值格式错误 Like hasPermission(['permission-1','permission-2'])`)
  return false
}
